import React from "react";
import './styles.scss';
import { addUserMessage, deleteMessages } from "../../../../../../../../store/actions";
import { useDispatch } from "react-redux";
import { MessageTypes } from "@types";
import socket from "../../../../../../../../socket/socket";
import { uuid } from "../../../../../../../../utils/uuid";

type PostageSendButtonProps = {
  message: MessageTypes;
};

const PostageSendButton: React.FC<PostageSendButtonProps> = ({
  message
}) => {
  const dispatch = useDispatch()

  const onClick = () => {
    const messageId = message.id
    
    dispatch(deleteMessages(1, messageId))
    dispatch(addUserMessage({
      text: message.text, senderName: message.senderName || '', messageId,
      isAcknowledged: false
    }))
    socket.sendMessage(messageId, message.text)
  }

  return <button
    className="postage-send-button"
    onClick={onClick}
    aria-label={'Отправить сообщение ещё раз'}
    tabIndex={0}
    type="button"
  >
    <span className="postage-send-button__icon">⟳</span>
  </button>
}

export default PostageSendButton;
